import React from "react"
import Back from "../common/Back"
import PriceCard from "../home/price/PriceCard"
import img from "../images/pricing.jpg"
import "../home/price/price.css"
import { useLanguage } from "../../context/LanguageContext"

const Pricing = () => {
  const { content } = useLanguage()
  const { pricingPage } = content

  return (
    <>
      <section className='pricing mb'>
        <Back name={pricingPage.backName} title={pricingPage.backTitle} cover={img} />
        <div className='price container'>
          <PriceCard />
        </div>
      </section>
    </>
  )
}

export default Pricing
